<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				myinfo: {},
				list: {
					audit_state: []
				},
				product_category_list: [],
				ad_list: []
			}
		},

		provide() {
			return {
				uploadurl: this.$axios.defaults.baseURL + "api/user/upload",
				uploadheader: {
					Authorization: $cookies.get('token')
				},
				appdata: this,
				reload: this.reload,
				onimgarr: this.onimgarr,
				oncopy: this.oncopy,
				formatDate: this.formatDate
			}
		},

		mounted() {
			this.onload();
			if (this.$cookies.get('token') && this.$route.path !== '/login') {
				this.oninfo();
			}
		},

		methods: {
			reload() {
				this.onload();
				this.oninfo();
			},

			onload() {
				this.$axios.get('adapipublic/config').then(res => {
					if (!res || !res.data) {
						return;
					}
					if (res.data.code == 0) {
						this.list = res.data.data;
						this.product_category_list = res.data.data.product_category_list.list;
						this.ad_list = res.data.data.ad_list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			oninfo() {
				this.$axios.get('api/user/info').then(res => {
					if (!res || !res.data) {
						return;
					}
					if (res.data.code == 0) {
						this.myinfo = res.data.data;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onimgarr(img) {
				if (img) {
					var imgArr = img.split(",");
					return imgArr
				} else {
					return []
				}
			},

			//复制
			oncopy(text) {
				if (text) {
					navigator.clipboard.writeText(text).then(() => {
						this.$message.success('复制成功');
					}).catch((err) => {
						console.error("复制失败");
					})
				}
			},

			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			}
		}
	}
</script>

<style lang="less">
	body {
		background-color: #f5f5f5;
	}

	.el-input__inner:hover {
		border-color: #ff4714 !important;
	}

	.el-input.is-active .el-input__inner,
	.el-input__inner:focus {
		border-color: #ff4714 !important;
	}

	.el-range-editor.is-active,
	.el-range-editor.is-active:hover,
	.el-select .el-input.is-focus .el-input__inner {
		border-color: #ff4714 !important;
	}

	.el-select .el-input__inner:focus {
		border-color: #ff4714 !important;
	}

	.el-menu-item.is-active {
		color: #ff4714 !important;
	}
	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: 2px solid #ff4714 !important;
	}
	.el-menu-item:focus,
	.el-menu-item:hover {
		background-color: initial !important;
	}

	.el-submenu__title:hover {
		background-color: initial !important;
	}

	.el-menu-item-group__title {
		display: none !important;
	}

	.el-button--primary {
		background-color: #F65730 !important;
		border-color: #F65730 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #F65730 !important;
		background: #F65730 !important;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #F65730 !important;
	}

	.btnbox {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 20px;
	}

	.filterdiv {
		// margin-bottom: 20px;
	}

	.pagediv {
		margin-top: 20px;
	}


	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #ff4714 !important;
		color: #fff !important;
	}

	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #ff4714 !important;
	}

	.tablebox {
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
	}

	.el-tabs__item.is-active {
		color: #F65730 !important;
	}

	.el-tabs__active-bar {
		background-color: #F65730 !important;
	}

	.el-tabs__item:hover {
		color: #F65730 !important;
	}

	.el-switch.is-checked .el-switch__core {
		border-color: #F65730 !important;
		background-color: #F65730 !important;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: #F65730 !important;
		background-color: #F65730 !important;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #F65730 !important;
	}

	.el-select-dropdown__item.selected {
		color: #F65730 !important;
	}

	.operation_i span {
		color: #F65730 !important;
		margin: 0 5px;
		cursor: pointer;
	}

	.filterty .el-select {
		width: 177px;
	}

	.uploadboxs {
		width: 100%;
		height: 160px;
		display: flex;
		padding: 50px 0;
		box-sizing: border-box;
	}

	.uploadboxs .uploadbox {
		width: 50%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.uploadboxs .uploadbox p {
		margin-bottom: 20px;
	}

	.uploadboxs .uploadbox .filenames {
		margin-top: 10px;
	}

	.uploadboxs .uploadbox .filenames .filename {
		display: flex;
		align-items: center;
	}

	.uploadboxs .uploadbox .filenames .filename span {
		margin-right: 20px;
	}

	.uploadboxs .uploadbox .filenames .filename i {
		font-size: 16px;
		color: #ff4714;
	}

	.uploadboxs .uploadbox:first-child {
		border-right: 1px solid #DCDFE6;
	}

	.el-button:focus,
	.el-button:hover {
		color: #ff4714 !important;
		background-color: #fff !important;
		border-color: #ff4714 !important;
	}

	.el-button--primary:focus,
	.el-button--primary:hover {
		color: #fff !important;
		background-color: #f65730 !important;
		border-color: #f65730 !important;
	}

	.custom-class {
		background-color: #f8f8fa !important;
		color: #333333;
	}

	.checked .el-input__inner {
		border-color: #F65730 !important;
	}

	.el-input-number__decrease:hover {
		color: #ff4714 !important;
	}

	.el-input-number__increase:hover {
		color: #ff4714 !important;
	}

	.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
		border-color: #F65730 !important;
	}

	.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
		border-color: #F65730 !important;
	}

	.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
	.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
		border-color: #F65730 !important;
	}

	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: #ecf5ff !important;
		color: #F65730 !important;
	}

	.el-textarea__inner:focus {
		border-color: #F65730 !important;
	}

	.yellor_row {
		background-color: #ffff00 !important;
	}

	.o_row {
		background-color: rgb(255, 153, 102) !important;
	}

	.y_row {
		background-color: #f65730 !important;
	}

	.zk {
		width: 100%;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #ff4714;
		position: relative;
		margin-bottom: 10px;
	}

	.zk span {
		background-color: #fff;
		z-index: 1;
		padding: 0 10px;
		cursor: pointer;
	}

	.zk::after {
		content: " ";
		display: flex;
		position: absolute;
		width: 100%;
		height: 2px;
		// background-color: #ff4714;
		background: radial-gradient(circle, #ff4714, 10%, #fff);
	}

	.el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #F65730 !important;
		border-color: #F65730 !important;
		box-shadow: -1px 0 0 0 #F65730 !important;
	}

	.el-radio-button__inner:hover {
		color: #F65730 !important;
	}

	.el-checkbox__inner:hover {
		border-color: #F65730 !important;
	}
	
	.myjg {
		color: #F65730;
	}
	
	.k {
		font-size: 12px;
		background-color: green;
		color: #fff;
		padding: 2px;
	}
	
	.j {
		font-size: 12px;
		background-color: blue;
		color: #fff;
		padding: 2px;
	}
	
	.uploaddiv {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
		.i_b {
			display: flex;
			align-items: center;
			
			.el-input {
				width: 300px !important;
				margin-right: 12px !important;
			}	
		}
		
		.a {
			color: #F65730;
			cursor: pointer;
		}
	}
	
	.ysy {
		color: #ffcc00 !important;
	}
	
	.ysb {
		color: #6ab5ff !important;
	}
	
	.myformitem {
		position: relative;
		
		.i {
			color: #ff4714;
			font-size: 20px;
			cursor: pointer;
			position: absolute;
			top: 50%;
			margin-top: -10px;
			right: 30px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue